import React from 'react';

export const PhaseCard = ({ number, title, description, delay = 0 }) => {
  return (
    <div
      className="phase-card glass-strong rounded-2xl p-8 relative overflow-hidden hover-lift"
      style={{ 
        transitionDelay: `${delay}ms`,
      }}
      data-testid={`phase-card-${number}`}
    >
      {/* Large background number */}
      <div className="phase-number">
        {number}
      </div>
      
      <h3 
        className="text-2xl md:text-3xl font-semibold mb-4 relative z-10"
        style={{ fontFamily: 'Playfair Display, serif', color: '#1A1A2E' }}
      >
        {title}
      </h3>
      <p 
        className="leading-relaxed relative z-10"
        style={{ color: '#4A4A5A' }}
      >
        {description}
      </p>
    </div>
  );
};

export default PhaseCard;
